<mat-selection-list #matSelection role="list" class="list-plantillas" (selectionChange)="getSelected($event)">
  <mat-list-option *ngFor="let usuario of usuariosList" [value]="usuario">
    {{ usuario.IdUsuario + ' - ' + usuario.Nusuario }}
  </mat-list-option>
</mat-selection-list>